module.exports = __webpack_public_path__ + "static/V7_000_Logo-392f6add1ecb53032bdbaca705cea1b4.png";